import { utcTimeInOffset } from "helpers/date";
import { buildQuery, containsQuery, OdataFilters, queryCollection, queryParams } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/car";
const trucksQuery = { orderBy: ["id desc"] };
const withoutDeletedQuery = { filter: { isDeleted: false } };

const getCarLastBidInfo = (id: number) => request(`${resource}/getCarLastBidInfo/${id}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...trucksQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = (params: {}) =>
    request(`${resource}/getlist${containsQuery(params, withoutDeletedQuery)}`, { method: "GET" });

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...trucksQuery });
    return request(`${resource}/getListExcel${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Грузовики.xlsx"),
    );
};

const listWithDeleted = (params: {}) => request(`${resource}/getlist${containsQuery(params)}`, { method: "GET" });

const getCountOfCarsWithExternalOutputForPlanning = () =>
    request(`${resource}/getCountOfCarsWithExternalOutputForPlanning`, { method: "GET" });

const numbersList = (params: {}) =>
    request(`${resource}/getNumbersList${containsQuery(params, withoutDeletedQuery)}`, { method: "GET" });

const filteredNumbersList = (params: {}, ids: number[]) =>
    request(`${resource}/getNumbersList${containsQuery(params, { filter: { isDeleted: false, id: { in: ids } } })}`, {
        method: "GET",
    });

const numbersListWithDeleted = (params: {}) =>
    request(`${resource}/getNumbersList${containsQuery(params)}`, { method: "GET" });

const carNumbersWithBids = (params: {}) =>
    request(`${resource}/getNumbersList${containsQuery(params)}&showCarsWithBids=true`, { method: "GET" });

const getAvailabilityStatus = (id: number) => request(`${resource}/getAvailabilityStatus/${id}`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const getCarStops = (filter: {}) => {
    const query = buildQuery({ filter });
    return request(`${resource}/getStops${query}`, { method: "GET" });
};

const getCarsInfo = ({ key, startedAt, endedAt }: { key: string; startedAt: string; endedAt: string }) => {
    const params = {
        ...(key ? { key } : {}),
        startedAt: utcTimeInOffset(startedAt, "00:00:00"),
        endedAt: utcTimeInOffset(endedAt, "00:00:00"),
    };
    const query = queryParams(params);
    return request(`${resource}/getCarsInfo${query}`, { method: "GET" });
};

const getItem = (params: { id: number }) => request(`${resource}/getForEdit?id=${params.id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const getFuelInfoForRefuelPlanning = (id: number) =>
    request(`${resource}/getFuelInfoForRefuelPlanning?id=${id}`, { method: "GET" }).then((data) => {
        if (data) {
            data.fuelTanks.forEach((item: { relationType: string }) => {
                item.relationType = "Car";
            });
        }
        return data;
    });

const applyPlanningComment = (params: {}) => alertRequest(`${resource}/applyPlanningComment`, body(params));
const applyBookingComment = (params: {}) => alertRequest(`${resource}/applyBookingComment`, body(params));
const applyNote = (params: {}) => alertRequest(`${resource}/applyNote`, body(params));

const setResourceActivity = (params: {}) => alertRequest(`${resource}/setResourceActivity`, body(params));

const applyCarLogistPeriod = (params: {}) => alertRequest(`${resource}/applyCarLogistPeriod`, body(params));

const getCarLogistPeriods = ({ preparedFilter, truckId, ...params }: OdataFilters & { truckId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(`${resource}/getCarLogistPeriods/${truckId}${query}`, { method: "GET" }, { countInHeaders: true });
};

const getCarLogistPeriod = ({ id }: { id: number }) =>
    request(`${resource}/getCarLogistPeriod/${id}`, { method: "GET" });

const deleteCarLogistPeriod = (params: {}) => alertRequest(`${resource}/deleteCarLogistPeriod`, body(params));

const addCarsToRefuelingSyncList = (params: {}) => alertRequest(`${resource}/addCarsToRefuelingSyncList`, body(params));

const addAllCarsToRefuelingSyncList = () => alertRequest(`${resource}/addAllCarsToRefuelingSyncList`, body({}));

const removeCarsFromRefuelingSyncList = (params: {}) =>
    alertRequest(`${resource}/removeCarsFromRefuelingSyncList`, body(params));

const removeAllCarsFromRefuelingSyncList = () =>
    alertRequest(`${resource}/removeAllCarsFromRefuelingSyncList`, body({}));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

export {
    index,
    apply,
    getCarStops,
    getCarsInfo,
    getItem,
    delItem,
    list,
    numbersList,
    listWithDeleted,
    carNumbersWithBids,
    getAvailabilityStatus,
    applyPlanningComment,
    applyBookingComment,
    getFuelInfoForRefuelPlanning,
    getCountOfCarsWithExternalOutputForPlanning,
    setResourceActivity,
    numbersListWithDeleted,
    getCarLastBidInfo,
    applyCarLogistPeriod,
    getCarLogistPeriods,
    getCarLogistPeriod,
    deleteCarLogistPeriod,
    addCarsToRefuelingSyncList,
    addAllCarsToRefuelingSyncList,
    removeCarsFromRefuelingSyncList,
    removeAllCarsFromRefuelingSyncList,
    restore,
    applyNote,
    getListExcel,
    filteredNumbersList,
};
